import {Routes} from '@angular/router';
import {ProfileComponent} from './profile.component';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';

function adminRedirectGuard() {
  const router = inject(Router);
  const authService = inject(AuthService);
  if (authService.isAdmin()) {
    router.navigateByUrl('/admin').then();
    return true;
  }
  return true;
}

export const ROUTES: Routes = [
  {
    path: '',
    component: ProfileComponent,
    children: [
      {
        path:'',
        pathMatch:'full',
        canMatch: [adminRedirectGuard],
        loadComponent: ()=> import('./pages/my-events/my-events.component').then(c => c.MyEventsComponent),
      },
      {
        path:'admin',
        pathMatch:'full',
        loadComponent: ()=> import('./admin/pages/my-events/my-events.component').then(c => c.MyEventsComponent),
      },
      {
        path: 'profile-edit',
        loadComponent: ()=> import('./pages/edit/edit.component').then(c=> c.EditComponent)
      },
      {
        path: 'settings',
        loadComponent: ()=> import('./pages/settings/settings.component').then(c=> c.SettingsComponent)
      },
    ]
  }
]
